import fetch from '../../../../utils/fetch';
import * as types from './mutation_types';
import moment from 'moment';

export const retrieve = ({ commit }, id) => {
  commit(types.AUDIO_SHOW_TOGGLE_LOADING);

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      data.created = moment(data.created).format("Y-MM-DD");
      commit(types.AUDIO_SHOW_TOGGLE_LOADING);
      commit(types.AUDIO_SHOW_SET_RETRIEVED, data);
    })
    .catch((e) => {
      commit(types.AUDIO_SHOW_TOGGLE_LOADING);
      commit(types.AUDIO_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.AUDIO_SHOW_RESET);
};



// WEBPACK FOOTER //
// ./src/store/modules/audio/show/actions.js